import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { getters } from '/@/modules/core/app/helpers/store';

export class CurrencySelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      ...config,
      placeholder: '$',
      label: 'code',
      trackBy: 'id',
      selectLabel: '',
      preselectFirst: true,
      showLabels: false,
      customLabel: ({ code, symbol }) => `${code} (${symbol})`
    });
  }

  /**
   * @returns {Promise<*>}
   */
  async getOptions(params = {}) {
    return getters.predefined.getCurrencies(params);
  }
}
